import { type PropsWithChildren, useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { colors } from "@covertree/theme/colors";

export interface Props extends PropsWithChildren {
  isRequirementMet: boolean;
}

export const PasswordRequirementIndicator = ({
  children,
  isRequirementMet,
}: Props) => {
  const theme = useTheme();

  const Icon = useMemo(
    () => (isRequirementMet ? DoneIcon : CloseIcon),
    [isRequirementMet]
  );

  return (
    <Grid container>
      <Grid item>
        <Icon
          sx={{
            fontSize: theme.spacing(2.5),
            marginRight: theme.spacing(0.75),
            color: isRequirementMet ? colors.green3 : colors.grey1,
          }}
        />
      </Grid>
      <Grid item>
        <Typography
          mt={0.15}
          variant="subtitle1"
          sx={{
            color: isRequirementMet ? colors.green3 : colors.grey1,
          }}>
          {children}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PasswordRequirementIndicator;
